import { themes } from "segments/segments-service";
export default {
    text: "Tag",
    color: Object.keys(themes)[0]
};
